import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  standalone: false,
})
export class IframeDialogComponent implements OnInit {
  title: string;
  safeIframeUrl: SafeResourceUrl;
  iframeHeight: string;

  constructor(
    public dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.title = this.data?.title || 'URL Checker';
    this.iframeHeight = this.data?.iframeHeight || '100%';

    if (!this.data?.iframeUrl) return;

    const processedUrl = this.processUrl(this.data.iframeUrl);
    if (!processedUrl) return;

    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, processedUrl);
    if (!sanitizedUrl) return;

    this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedUrl);
  }

  private processUrl(url: string): string | null {
    if (!url?.trim()) return null;

    let processedUrl = url.trim();

    try {
      const urlObj = new URL(processedUrl);
      return urlObj.href;
    } catch {
      if (!processedUrl.startsWith('http://') && !processedUrl.startsWith('https://')) {
        processedUrl = 'https://' + processedUrl;
      }

      try {
        new URL(processedUrl);
        return processedUrl;
      } catch {
        return null;
      }
    }
  }
}
